import { useMemo } from 'react'
import { useLocation } from 'react-router'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { DEFAULT_SALES_REPORT_VARIANT } from '../constants/defaultSalesReportVariant'
import { salesReportVariantRoutes } from '../utils/salesReportVariantRoutes'

export const useSalesReportVariant = () => {
  const { organization } = useUserOrganization()
  const { pathname } = useLocation()

  const salesReportVariant = useMemo(() => {
    if (!organization?.url) {
      return DEFAULT_SALES_REPORT_VARIANT
    }

    return (
      salesReportVariantRoutes.find((route) => pathname === route.getVariantRoute(organization.url))?.variant ||
      DEFAULT_SALES_REPORT_VARIANT
    )
  }, [organization?.url, pathname])

  return { salesReportVariant }
}
